import {v4 as uuidv4} from 'uuid';
//form configuration;
import {EventSponsor} from '../../../formConfiguration';
import { IOrganizationSponsorCategoryResponse } from '@/utils/types';
import { OrganizationEventService } from '@/utils/services';

// export const handleGetSponsor = (
//   sponsors: EventSponsor[] | null,
//   editableSponsor: EventSponsor | null,
//   sponsorLogo: File | null | string,
//   sponsorName: string,
// //   sponsorCategoryId: string | null,
//   sponsorCategoryName: string,
//   sponsorOrder: number
// ) => {
//   const updatedSponsors = (sponsors || []).map((sponsor) =>
//     editableSponsor && sponsor.id === editableSponsor.id
//       ? {...sponsor, logo: sponsorLogo, name: sponsorName, categoryId: sponsorCategoryId}
//       : sponsor
//   );

//   if (!editableSponsor) {
//     updatedSponsors.push({
//       id: uuidv4(),
//       logo: sponsorLogo!,
//       name: sponsorName,
//       category: {name: sponsorCategoryName, sortOrder: sponsorOrder},
//       categoryId: sponsorCategoryId,
//       sortOrder: sponsorOrder,
//     });
//   }

//   return updatedSponsors;
// };

export const handleGetSponsor = (
  sponsors: EventSponsor[] | null,
  editableSponsor: EventSponsor | null,
  sponsorLogo: File | null | string,
  sponsorName: string,
  sponsorCategoryName: string,
  sponsorOrder: number
) => {
  const updatedSponsors = (sponsors || []).map((sponsor) =>
    editableSponsor && sponsor.id === editableSponsor.id
      ? {
          ...sponsor,
          logo: sponsorLogo,
          name: sponsorName,
          category: {...sponsor.category, name: sponsorCategoryName},
          sortOrder: sponsorOrder,
        }
      : sponsor
  );

  if (!editableSponsor) {
    updatedSponsors.push({
      id: uuidv4(),
      logo: sponsorLogo!,
      name: sponsorName,
      category: {name: sponsorCategoryName, sortOrder: sponsorOrder},
      sortOrder: sponsorOrder,
    } as EventSponsor);
  }

  return updatedSponsors;
};

export const resolveCategoryId = async (
  organizationId: number,
  categoryName: string,
  existingCategories: IOrganizationSponsorCategoryResponse[],
  categoriesCache: Map<string, number>
): Promise<number> => {
  const key = categoryName.trim().toLowerCase();

  const matched = existingCategories.find((c) => c.name.trim().toLowerCase() === key);
  if (matched) return matched.id;

  if (categoriesCache.has(key)) return categoriesCache.get(key)!;

  const {data: createdCategory} =await OrganizationEventService.createSponsorCategory(organizationId, categoryName.trim());

  categoriesCache.set(key, createdCategory.id);
  return createdCategory.id;
};
